import React, { InputHTMLAttributes } from 'react'

import useSmallScreens from '@probatix/common/hooks/useSmallScreens'

import {
  StyledInput,
  StyledInputWrapper,
  StyledLabel,
  StyledRight,
  StyledInputBox,
} from './Input.styled'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  $hasError: boolean;
  autoComplete?: string;
  disabled?: boolean;
  errorMargin?: string;
  label: string | React.ReactNode;
  margin?: string;
  maskType: any;
  max?: string | number;
  maxWidth?: string;
  minWidth?: string;
  name: string;
  placeholder?: never;
  ref?: React.Ref<HTMLInputElement>;
  required?: boolean;
  right?: React.ReactNode;
  textTransform?: string;
  type?: string;
}

const Input: React.FC<InputProps> = ({
  $hasError,
  autoComplete,
  disabled,
  label,
  margin,
  maskType, 
  max,
  maxWidth,
  minWidth,
  name,
  placeholder,
  ref,
  required,
  right,
  textTransform = 'none',
  type,
  ...rest
}) => {
  const [$isSmallScreen] = useSmallScreens()

  const { onChange, ...otherRest } = rest

  const handleMaskChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if ('triple-dash' === maskType) {
      let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '') 
      
      if (9 < value.length) value = value.substring(0, 9) 

      const matches = value.match(/.{1,3}/g)
      if (matches) {
        value = matches.join('-')
      }
      
      e.target.value = value 
    }
    
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <StyledInputWrapper
      $disabled={disabled}
      $hasError={$hasError}
      margin={margin}
    >
      <StyledInputBox className={$hasError ? "hasError" : ''}>
        <StyledInput
          $isSmallScreen={!!$isSmallScreen}
          autoComplete={autoComplete}
          data-qa={name}
          data-testid={name}
          disabled={!!disabled}
          max={max}
          maxWidth={maxWidth}
          minWidth={minWidth}
          name={name}
          placeholder={placeholder}
          ref={ref}
          required={!!required}
          textTransform={textTransform}
          type={type}
          {...otherRest} 
          onChange={handleMaskChange}
        />
        <StyledLabel aria-label={'string' === typeof label ? label : undefined}>
          {label}
        </StyledLabel>
        {right && <StyledRight>{right}</StyledRight>}
      </StyledInputBox>
    </StyledInputWrapper >
  )
}

export default Input
